import { get } from 'lodash';
import React, { FC } from 'react';
import CreateTable from '../../../../../../components/ui-component/form-component/create-form/CreateTable';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
import Schema from '../../../../../../lib/paths/zwischenbericht_FULL_Paths.json';
import { FormStrucItem } from '../../../../../../lib/types/types';
import { NonRequired } from '../../../../../../lib/validation/ValidationTypes';
import { isTrue } from '../../../../../../utils/helper';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
const P = Schema.attributes;

const Interessensbekundungen: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title='Interessensbekundungen' description={PLATZHALTER_TEXT} />
			<CreateTable
				formStruc={formStrucInteressensbekundungen(application)}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={readOnly}
				columnsLabel={columnsLabel()}
			/>
		</>
	);
};
export default Interessensbekundungen;

const columnsLabel = () => {
	let labels = ['', 'Angabe', 'Anzahl'];
	return labels;
};
export const formStrucInteressensbekundungen = (application: any) => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					type: 'label',
					path: P.Interessensbekundungen_u_0185013621_t_Verwertung_Erwartet_Angabe.path,
				},

				{ ...P.Interessensbekundungen_u_0185013621_t_Verwertung_Erwartet_Angabe, type: 'radio', validation: [{ validateFunction: NonRequired }] },
				...(isTrue(get(application, P.Interessensbekundungen_u_0185013621_t_Verwertung_Erwartet_Angabe.path)) ?
					[P.Interessensbekundungen_u_0185058588_t_Verwertung_Erwartet_Anzahl]
				:	[]),
			],
		},
		{
			fields: [
				{
					type: 'label',
					path: P.Interessensbekundungen_Kontakte_Zu_Zielkunden_Aufgebaut_Angabe.path,
				},

				{ ...P.Interessensbekundungen_Kontakte_Zu_Zielkunden_Aufgebaut_Angabe, type: 'radio', validation: [{ validateFunction: NonRequired }] },
				...(isTrue(get(application, P.Interessensbekundungen_Kontakte_Zu_Zielkunden_Aufgebaut_Angabe.path)) ?
					[P.Interessensbekundungen_Kontakte_Zu_Zielkunden_Aufgebaut_Anzahl]
				:	[]),
			],
		},
		{
			fields: [
				{
					type: 'label',
					path: P.Interessensbekundungen_Auftraege_In_Kuerze_Erwartet_Angabe.path,
				},

				{ ...P.Interessensbekundungen_Auftraege_In_Kuerze_Erwartet_Angabe, type: 'radio', validation: [{ validateFunction: NonRequired }] },
				...(isTrue(get(application, P.Interessensbekundungen_Auftraege_In_Kuerze_Erwartet_Angabe.path)) ?
					[P.Interessensbekundungen_Auftraege_In_Kuerze_Erwartet_Anzahl]
				:	[]),
			],
		},
	];

	return struc;
};
